import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import Widget from "../../components/widget/Widget";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Datatable from "../../components/datatable/Datatable";
import OutOfStock from "../stockmanagement/OutOfStock";
import axios from "axios";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";

const Home = () => {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({
    supplier: "",
    customer: "",
    order: "",
    order_active: "",
    order_delivery: "",
    product: "",
    new_customer: "",
    top_users: "",
    out_for_delivery: "",
    total_sale: "",
    today_total_sale: "",
    graph: [],
  });

  useEffect(() => {
    if (!localStorage.getItem("status")) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    axios.get("https://dawabajar.encantotech.in/api/dashboard_data").then((res) => {
      if (res.data.status === "Success") {
        setDashboardData({
          supplier: res.data.data?.supplier,
          customer: res.data.data?.customer,
          order: res.data.data?.order,
          order_active: res.data.data?.order_active,
          order_delivery: res.data.data?.order_delivery,
          product: res.data.data?.product,
          new_customer: res.data.data?.new_customer,
          top_users: res.data.data?.top_users,
          out_for_delivery: res.data.data?.out_for_delivery,
          total_sale: res.data.data?.total_sale,
          today_total_sale: res.data.data?.today_total_sale,
          graph: res.data.data?.graph || [],
        });
      } else {
        setDashboardData({
          supplier: [],
          customer: [],
          order: [],
          order_active: [],
          order_delivery: [],
          product: [],
          new_customer: [],
          top_users: [],
          out_for_delivery: [],
          total_sale: [],
          today_total_sale: [],
          graph: [],
        });
      }
    });
  }, []);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            fontSize: "14px",
          }}
        >
          <p style={{ margin: "0", color: "#333" }}>{`Date: ${label}`}</p>
          <p style={{ margin: "5px 0", color: "#8884d8" }}>
            {`Total Sales: ₹${payload[0].value.toLocaleString("en-IN")}`}
          </p>
          <p style={{ margin: "5px 0", color: "#82ca9d" }}>
            {`Total Orders: ${payload[1].value}`}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="container-fluid">
      <style>
        {`
          .chart-container {
            background-color: #fff;
            border-radius: 12px;
            padding: 24px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            max-width: 1200px;
            margin: 0 auto;
          }
          .chart-title {
            font-size: 1.5rem;
            font-weight: 600;
            color: #1D718B;
            text-align: center;
            margin-bottom: 1.5rem;
          }
        `}
      </style>
      <div className="row">
        <div className="col-2 p-0">
          <Sidebar />
        </div>
        <div className="col-10">
          <div className="container-fluid p-0">
            <Navbar />
            <div className="home">
              <div className="homeContainer">
                <div className="row">
                  <div className="col-12">
                    <div className="widgets">
                      <Widget type="user" data={dashboardData.customer} />
                      <Widget type="order" data={dashboardData.product} />
                      <Widget type="earning" data={dashboardData.supplier} />
                      <Widget type="balance" data={dashboardData.order} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="widgets">
                      <Widget type="newcustomer" data={dashboardData.new_customer} />
                      <Widget type="selling" data={dashboardData.order_active} />
                      <Widget type="outfordelivery" data={dashboardData.out_for_delivery} />
                      <Widget type="totalsale" data={dashboardData.total_sale} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="widgets">
                      <Widget type="todaytotalsale" data={dashboardData.today_total_sale} />
                      <Widget type="topusers" data={dashboardData.top_users} />
                    </div>
                  </div>
                </div>
                {dashboardData.graph.length > 0 && (
                  <div className="row my-5">
                    <div className="col-12">
                      <div className="chart-container">
                        <h5 className="chart-title">Sales and Orders Overview</h5>
                        <ResponsiveContainer width="100%" height={400}>
                          <BarChart
                            data={dashboardData.graph}
                            margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                            barSize={30}
                            barGap={10}
                          >
                            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                            <XAxis
                              dataKey="date"
                              tick={{ fontSize: 12, fill: "#555" }}
                              angle={-45}
                              textAnchor="end"
                            />
                            <YAxis
                              yAxisId="left"
                              orientation="left"
                              stroke="#8884d8"
                              tick={{ fontSize: 12 }}
                              tickFormatter={(value) => `₹${value.toLocaleString("en-IN")}`}
                            />
                            <YAxis
                              yAxisId="right"
                              orientation="right"
                              stroke="#82ca9d"
                              tick={{ fontSize: 12 }}
                            />
                            <Tooltip content={<CustomTooltip />} />
                            <Legend
                              wrapperStyle={{
                                paddingTop: "20px",
                                fontSize: "14px",
                                fontWeight: 500,
                              }}
                            />
                            <Bar
                              yAxisId="left"
                              dataKey="total_sales"
                              fill="#8884d8"
                              name="Total Sales (₹)"
                              radius={[4, 4, 0, 0]}
                              animationDuration={1000}
                            >
                              <LabelList
                                dataKey="total_sales"
                                position="top"
                                formatter={(value) => `₹${value.toLocaleString("en-IN")}`}
                                style={{ fontSize: 12, fill: "#333" }}
                              />
                            </Bar>
                            <Bar
                              yAxisId="right"
                              dataKey="total_orders"
                              fill="#82ca9d"
                              name="Total Orders"
                              radius={[4, 4, 0, 0]}
                              animationDuration={1000}
                            >
                              <LabelList
                                dataKey="total_orders"
                                position="top"
                                style={{ fontSize: 12, fill: "#333" }}
                              />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </div>
                )}
                <div className="my-5">
                  <OutOfStock />
                </div>
                <div className="my-5">
                  <Datatable />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;